import { useQuery } from '@tanstack/react-query';
import type { UseQueryResult } from '@tanstack/react-query';
import { macchineService } from '@/services/macchineService';
import { queryKeys } from '@/lib/queryKeys';
import { usePermissions } from './usePermissions';
import type { MachineAlertsFilters, MachineAlertsResponse } from '@/types';

export function useMachineAlerts(
  filters: MachineAlertsFilters = {},
  options: { enabled?: boolean } = {},
): UseQueryResult<MachineAlertsResponse> {
  const { isStaff } = usePermissions();
  const enabled = (options.enabled ?? true) && isStaff;

  return useQuery({
    queryKey: queryKeys.macchine.alerts(filters),
    queryFn: () => macchineService.alerts(filters),
    enabled,
    staleTime: 15_000,
    meta: { resourceName: 'macchine in allarme' },
  });
}

/** Sidebar badge: unfiltered alarm count. Independent of the page URL. */
export function useMachineAlertsCount(): UseQueryResult<number> {
  const { isStaff } = usePermissions();

  return useQuery({
    queryKey: queryKeys.macchine.alertsCount,
    queryFn: async () => {
      const response = await macchineService.alerts({ page: 1, pageSize: 1 });
      return response.kpis.totale;
    },
    enabled: isStaff,
    staleTime: 15_000,
    meta: { resourceName: 'conteggio allarmi' },
  });
}
